import { FormControl, FormHelperText, MenuItem, Select } from '@mui/material';
import React, { useEffect } from 'react';
import { Controller } from 'react-hook-form';
import styled from 'styled-components';
import { FormInputProps, ISelectInput } from './InputInterface';

const DabaduSelect = styled(FormControl)`
  & .MuiInputBase-root {
    font-weight: 300;
    font-size: 1rem;
    letter-spacing: 0;
    line-height: 1.5;
    font-family: ${(props) => props.theme.fonts.primary};
    color: ${(props) => props.theme.colors.textColor};
  }
  & .MuiOutlinedInput-notchedOutline {
    border-color: ${(props) => props.theme.colors.inputBorder};
  }
  & .MuiSelect-outlined {
    &.MuiSelect-select {
      min-height: auto;
      padding: 18px 20px;

      @media (max-width: 1650px) {
        padding: 12px 14px;
      }
    }
  }
  & .MuiOutlinedInput-root {
    &:hover,
    &:active {
      .MuiOutlinedInput-notchedOutline {
        border-color: ${(props) => props.theme.colors.inputBorder};
      }
    }
    &.Mui-focused {
      .MuiOutlinedInput-notchedOutline {
        border-width: 1px;
        border-color: ${(props) => props.theme.colors.inputBorder};
      }
    }
  }
  & .MuiFormHelperText-root {
    margin-left: 0;
    color: ${(props) => props.theme.colors.dangerColor};
    font-family: ${(props) => props.theme.fonts.primary};
  }
`;

export const SelectInput: React.FC<FormInputProps & ISelectInput> = ({
  name,
  control,
  label,
  options,
  rules,
  triggerValidationForField,
  defaultValue = '',
  onChangeHandler,
}) => {
  const generateSingleOptions = () => {
    return options.map((option: any) => {
      return (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      );
    });
  };

  const [selectVal, setSelectVal] = React.useState('');

  useEffect(() => {
    if (defaultValue) {
      setSelectVal(defaultValue);
      triggerValidationForField(name);
    }
  }, [defaultValue]);

  return (
    <DabaduSelect fullWidth>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field: { onChange }, formState: { errors } }) => (
          <>
            {label && <label className='control-label'>{label}</label>}

            <Select
              placeholder={label}
              value={selectVal}
              onChange={(e) => {
                onChange(e.target.value);
                triggerValidationForField(name);
                onChangeHandler?.(e.target.value);
              }}
              defaultValue={defaultValue}
              displayEmpty
            >
              {generateSingleOptions()}
            </Select>
            {errors?.[name] && <FormHelperText>{errors?.[name]?.message}</FormHelperText>}
          </>
        )}
      />
    </DabaduSelect>
  );
};
